import React, { Component } from 'react';
import { node } from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import styles from './tooltipButton.module.css';
import sharedStyles from '../../styles/shared';

class TooltipButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      rightSideTooltip: false
    };

    this.toggle = this.toggle.bind(this);
  }

  // Used by onClickOutside
  handleClickOutside() {
    this.setState({
      isOpen: false
    });
  }

  toggle(e) {
    const rightSideTooltip = e.nativeEvent.clientX > window.innerWidth / 2;
    const maxWidth = `${(window.innerWidth / 3) * 2}px`;

    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      rightSideTooltip,
      maxWidth
    }));
  }

  render() {
    const direction = this.state.rightSideTooltip ? styles.right : styles.left;
    const hidden = this.state.isOpen ? '' : sharedStyles.hidden;

    return (
      <div className={styles.container}>
        <button type="button" onClick={this.toggle} className={styles.button}>
          {this.props.children}
        </button>
        <div
          className={`${styles.content} ${hidden} ${direction}`}
          style={{ maxWidth: this.state.maxWidth }}
        >
          {this.props.content}
        </div>
      </div>
    );
  }
}

TooltipButton.propTypes = {
  content: node,
  children: node.isRequired
};

TooltipButton.defaultProps = {
  content: ''
};

export default onClickOutside(TooltipButton);
